import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiltersStateExceptionExport } from "./type";

const initialState: FiltersStateExceptionExport = {
  fromDate: null,
  toDate: null,
};

const filtersSliceExceptionExport = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<Date | null>) {
      state.toDate = action.payload;
    },
  },
});

export const { setFromDate, setToDate } = filtersSliceExceptionExport.actions;
export default filtersSliceExceptionExport.reducer;
